/* DROPS — Shopify Theme JS
   Vanilla JS: Past Drops Carousel
*/

(function () {
  'use strict';

  /* ── Utility: debounce ── */
  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  /* ── Past Drops Carousel ── */
  function initCarousels() {
    var tracks = document.querySelectorAll('.carousel-track');

    tracks.forEach(function (track) {
      var viewport = track.parentElement;
      var wrap     = viewport ? viewport.parentElement : null;

      if (!viewport || !wrap) return;

      var prevBtn  = wrap.querySelector('.carousel-prev');
      var nextBtn  = wrap.querySelector('.carousel-next');

      if (!prevBtn || !nextBtn) return;

      var GAP          = 24;
      var currentIndex = 0;

      /* Determine how many cards are visible based on viewport width */
      function getVisible() {
        return window.innerWidth <= 768 ? 1 : 3;
      }

      function getCardWidth() {
        var VISIBLE = getVisible();
        return (viewport.offsetWidth - GAP * (VISIBLE - 1)) / VISIBLE;
      }

      function getMaxIndex() {
        var cards   = track.querySelectorAll('.past-card');
        var VISIBLE = getVisible();
        return Math.max(0, cards.length - VISIBLE);
      }

      function setButtonState(index) {
        var atStart = (index === 0);
        var atEnd   = (index >= getMaxIndex());

        prevBtn.disabled             = atStart;
        prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');

        nextBtn.disabled             = atEnd;
        nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      function slideTo(index) {
        var step = getCardWidth() + GAP;
        track.style.transform = 'translateX(-' + (index * step) + 'px)';
        currentIndex = index;
        setButtonState(index);
      }

      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          slideTo(currentIndex - 1);
        }
      });

      nextBtn.addEventListener('click', function () {
        var max = getMaxIndex();
        if (currentIndex < max) {
          slideTo(currentIndex + 1);
        }
      });

      /* Debounced resize: prevents layout thrash and flicker */
      window.addEventListener('resize', debounce(function () {
        /* Clamp index to new max in case screen got wider */
        var clampedIndex = Math.min(currentIndex, getMaxIndex());
        slideTo(clampedIndex);
      }, 120));

      /* Init state */
      slideTo(0);
    });
  }

  /* ── Run on DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

})();
